import * as yup from 'yup';
import { requiredErrorMessage } from '@common/schema';

export const bedsSchema = yup.object().shape({
  assisted_living: yup
    .number()
    .min(0)
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
  memory_care: yup
    .number()
    .min(0)
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
  senior_living: yup
    .number()
    .min(0)
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
  independent_living: yup
    .number()
    .min(0)
    .required(requiredErrorMessage)
    .typeError(requiredErrorMessage),
});
